<template>
  <div class="container page page-home">

    <div :class="{ card: !isMobile }">
      <div :class="{ 'card-body': !isMobile }">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" :class="{ 'pl-0 pr-0': isMobile }">
            <transition name="appear">
              <trip-planner-widget key="widget2" :isFuture="isFuture" v-if="pageReady" class="mt-2"></trip-planner-widget>
            </transition>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" :class="{ 'with-border' : !isMobile, 'pl-0 pr-0 mt-3' : isMobile }">
            <transition name="appear-delay-02s">
              <routes-nearby-widget :isWidget="true" :isFuture="isFuture" v-if="pageReady" class="mt-2"></routes-nearby-widget>
            </transition>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import RoutesNearbyWidget from '@/components/RoutesNearbyWidget.vue'
import TripPlannerWidget from '@/components/TripPlannerWidget.vue'
import mixinCommon from '../mixins/common'

export default {
  name: 'home',
  components: {
    RoutesNearbyWidget, TripPlannerWidget
  },
  mixins: [mixinCommon],
  data () {
  	return {
      isFuture: window.showFutureRoutes || false,
      pageReady: false,
  	}
  },
  mounted () {
  	this.pageReady = true
  	// setTimeout(() => this.pageReady = true, 1000)
  }
}
</script>
<style lang="scss">
.list-enter-active, .list-leave-active {
  transition: all 0.5s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}

.page.page-home > div {
  // border:solid 1px red;
  // float: left;
  // width: 50%;
}

</style>
<style lang="scss" scoped>
.card {
  border-radius: 0;
  border-top-left-radius: 35px;
  border-top-right-radius: 35px;
}

</style>


// WEBPACK FOOTER //
// src/views/Home.vue